import React, { useEffect, useState } from "react";

import myke from "../../images/myke-heade.png";
import stephen from "../../images/stephen-head.png";

const Scoreboard = (props) => {
  const [stephenPoints, setStephenPoints] = useState(0);
  const [mykePoints, setMykePoints] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      fetch(process.env.REACT_APP_APIGATEWAY, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ function: "scan" }),
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          // console.log(
          //   "data 0:",
          //   data.Items[0].id,
          //   data.Items[0].person,
          //   data.Items[0].score,
          //   "data 1:",
          //   data.Items[1].id,
          //   data.Items[1].person,
          //   data.Items[1].score
          // );
          setStephenPoints(data.Items[1].score);
          setMykePoints(data.Items[0].score);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }, 5000);

    return () => clearInterval(timer); //This is important
  }, []);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const size = urlParams.get("size");

  return (
    <div
      className={
        size === "small"
          ? "scoreboard-score small"
          : props.size === "page"
          ? "scoreboard-score page"
          : "scoreboard-score big"
      }
    >
      <div className="head_wrapper">
        <div className="myke">
          <img src={myke} alt="myke head" />
          <p>{mykePoints}</p>
        </div>
        <div className="stephen">
          <img src={stephen} alt="stephen head" />
          <p>{stephenPoints}</p>
        </div>
      </div>
    </div>
  );
};

export default Scoreboard;
